import { BjThemeColors } from '@type/bj_theme';
import { BadgePill } from '@components/common';
import { useTranslation } from 'next-i18next';
import { applicantStatusIdObj } from '@components/templates/employer/applicant-list/functions/statusConstants';


/**
 * @description Applicant badge pill component
 * @param statusId - the status id of the applicant (number for new, interview, shortlist, etc.)
 */
export const ApplicantBadgePill = ({ statusId }: { statusId?: number }) => {
  // Find the status by statusId
  const status = statusId ? applicantStatusIdObj.find((item) => item.statusId === statusId) : undefined;
  const { t } = useTranslation('common');

  // If status is not found, return null
  if (!status) return null;

  // Return the badge pill
  return (
    <BadgePill
      color={status.color as BjThemeColors}
      size="xxs"
      className="max-w-24 !px-2 text-center font-medium leading-tight"
    >
      <span className="block text-wrap break-all text-pico">{t(status.label)}</span>
    </BadgePill>
  );
};
